import React, { useState } from 'react'
import Modal from 'react-modal'
import modalStyle from '../../../../../_common/core/modalStyle'
import Button from '../../../../_library/Button'
import Field from '../../../../_library/Field'
import { Form, Formik } from 'formik'
import ConfirmModal from '../../../../_library/ConfirmModal'
import { showAxiosError, showSuccessMessage } from '../../../../utils/messenger'
import { createSeasonEvent, updateEvent, deleteMap } from '../../../../../_common/core/http_services/seatsio'
import { OverlayTrigger } from '../../../../_library/OverlayTrigger'

export const SeatsIoSeasonEventsManager = ({ isOpen, onClose, seasonData, eventId, onEventsUpdated, hasSales = false }) => {
  const [editingEvent, setEditingEvent] = useState(null)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedEventId, setSelectedEventId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleEditEvent = event => {
    setEditingEvent(event)
  }

  const handleDeleteEvent = eventId => {
    setSelectedEventId(eventId)
    setShowDeleteModal(true)
  }

  const handleUpdateEvent = async values => {
    try {
      setIsLoading(true)
      await updateEvent({
        eventId,
        seatsIoEventId: editingEvent.id,
        name: values.name,
      })
      showSuccessMessage('Event updated successfully!')
      setEditingEvent(null)
      if (onEventsUpdated) {
        onEventsUpdated()
      }
    } catch (e) {
      showAxiosError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleCreateEvent = async values => {
    try {
      setIsLoading(true)
      await createSeasonEvent({
        eventId,
        name: values.name,
      })
      showSuccessMessage('Event created successfully!')
      setShowCreateModal(false)
      if (onEventsUpdated) {
        onEventsUpdated()
      }
    } catch (e) {
      showAxiosError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteConfirm = async response => {
    if (response === 'ok') {
      try {
        setIsLoading(true)
        await deleteMap(eventId, selectedEventId)
        showSuccessMessage('Event deleted successfully!')
        if (onEventsUpdated) {
          onEventsUpdated()
        }
      } catch (e) {
        showAxiosError(e)
      } finally {
        setIsLoading(false)
        setShowDeleteModal(false)
      }
    } else {
      setShowDeleteModal(false)
    }
  }

  return (
    <>
      <Modal
        className="modal-dialog modal-trans p5"
        style={modalStyle}
        isOpen={isOpen}
        ariaHideApp={false}
        contentLabel="Modal"
        onRequestClose={onClose}
        closeTimeoutMS={10}
      >
        <div style={{ backgroundColor: '#292d32', justifyContent: 'center' }}>
          <div className="modal-header">
            <p className="h4 text-compact">Manage Seat Maps</p>
          </div>
          <div className="modal-body">
            <div className="seats-io-events-list">
              <table className="table table-striped" style={{ textAlign: 'left' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left' }}>Name</th>
                    <th style={{ textAlign: 'left' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: 'left' }}>{seasonData?.name} (Main)</td>
                    <td style={{ textAlign: 'left' }}>
                      <Button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => handleEditEvent({ id: 'main', name: seasonData?.name })}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                  {seasonData?.season_events?.map(event => (
                    <tr key={event.id}>
                      <td style={{ textAlign: 'left' }}>{event.name}</td>
                      <td>
                        <Button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => handleEditEvent(event)}
                          style={{ marginRight: '5px' }}
                        >
                          Edit
                        </Button>
                        {hasSales ? (
                          <OverlayTrigger
                            placement="top"
                            id="deleteButtonTooltip"
                            tooltip={<span>Seat map cannot be deleted once ticket sales have started</span>}
                            delayShow={400}
                            delayHide={10}
                            className={'display-inline-block'}
                          >
                            <Button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteEvent(event.id)}
                              disabled={hasSales}
                            >
                              Delete
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          <Button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteEvent(event.id)}
                          >
                            Delete
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="text-center" style={{ marginTop: '20px' }}>
              <Button
                type="button"
                className="btn btn-success btn-shadow"
                onClick={() => setShowCreateModal(true)}
              >
                Create New Seat Map
              </Button>
            </div>
          </div>
          <div className="modal-footer">
            <div className="btn-toolbar">
              <Button type="button" className="btn btn-cancel btn-shadow" onClick={onClose}>
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Edit Event Modal */}
      <Modal
        className="modal-dialog modal-trans p5"
        style={modalStyle}
        isOpen={!!editingEvent}
        ariaHideApp={false}
        contentLabel="Modal"
        onRequestClose={() => setEditingEvent(null)}
        closeTimeoutMS={10}
      >
        <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
          <div className="modal-header">
            <p className="h4 text-compact">Edit Seat Map</p>
          </div>
          <Formik
            initialValues={{
              name: editingEvent?.name || '',
            }}
            validate={values => {
              const errors = {}
              if (!values.name) {
                errors.name = 'Required'
              }
              return errors
            }}
            onSubmit={handleUpdateEvent}
            enableReinitialize
          >
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
              <Form>
                <div className="modal-body">
                  <div className="col-xs-12 col-12">
                    <Field
                      id="name"
                      label="Seat Map Name"
                      value={values.name}
                      error={errors.name}
                      touched={touched.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar">
                    <Button
                      type="button"
                      className="btn btn-cancel btn-shadow"
                      onClick={() => setEditingEvent(null)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="btn btn-primary btn-shadow"
                      disabled={isLoading}
                      loading={isLoading}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      {/* Create Event Modal */}
      <Modal
        className="modal-dialog modal-trans p5"
        style={modalStyle}
        isOpen={showCreateModal}
        ariaHideApp={false}
        contentLabel="Modal"
        onRequestClose={() => setShowCreateModal(false)}
        closeTimeoutMS={10}
      >
        <div style={{ backgroundColor: '#292d32', justifyContent: 'center', textAlign: 'center' }}>
          <div className="modal-header">
            <p className="h4 text-compact">Create New Seat Map</p>
          </div>
          <Formik
            initialValues={{
              name: '',
            }}
            validate={values => {
              const errors = {}
              if (!values.name) {
                errors.name = 'Required'
              }
              return errors
            }}
            onSubmit={handleCreateEvent}
          >
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
              <Form>
                <div className="modal-body">
                  <div className="col-xs-12 col-12">
                    <Field
                      id="name"
                      label="Seat Map Name"
                      value={values.name}
                      error={errors.name}
                      touched={touched.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar">
                    <Button
                      type="button"
                      className="btn btn-cancel btn-shadow"
                      onClick={() => setShowCreateModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="btn btn-primary btn-shadow"
                      disabled={isLoading}
                      loading={isLoading}
                    >
                      Create
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        isOpen={showDeleteModal}
        header="Confirm Delete"
        content="Are you sure you want to delete this seat map? This action cannot be undone."
        actions={[
          { value: 'ok', label: 'Delete', className: 'btn btn-danger btn-shadow', loading: isLoading },
          { value: 'cancel', label: 'Cancel', className: 'btn btn-default' },
        ]}
        onAction={handleDeleteConfirm}
      />
    </>
  )
}

export default SeatsIoSeasonEventsManager
